import React from 'react';
import './ForWhom.css';

const ForWhom = () => {
  const items = [
    'Founders scaling their visibility and stepping into moments where public perception starts to shape outcomes',
    'CEOs preparing for inflection points such as fundraises, IPOs, or leadership transitions where narrative becomes critical',
    'CXOs expanding their influence and needing their external voice to match the weight of their role',
    'Leaders navigating scrutiny or reputation pressure where how they respond will define trust going forward',
    'Companies at a turning point whose narrative has not yet caught up with the reality of what they\'ve built'
  ];

  return (
    <section className="forwhom">
      <div className="forwhom-grid">
        <div>
          <p className="section-label">Who is it for?</p>
          <h2 className="section-heading">Built for leaders<br />in motion.</h2>
          <div className="forwhom-list">
            {items.map((item, index) => (
              <div key={index} className="forwhom-item">
                <div className="forwhom-dot"></div>
                <p className="forwhom-text">{item}</p>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="forwhom-right">
            <div className="forwhom-quote-rule"></div>
            <p className="forwhom-quote">“You can have brilliant ideas, but if you can’t get them across, your ideas won’t get you anywhere.”</p>
            <p className="forwhom-quote-attr">— Lee Iacocca</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForWhom;
